export default __webpack_public_path__ + "static/media/konteynerovoz.4bd774cd.svg";